/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Legacydebitornumbers2Inputs */



/**

* @param {_Field_Legacydebitornumbers2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_legacydebitornumbers2 = /** @type {((inputs?: _Field_Legacydebitornumbers2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Legacydebitornumbers2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Alte Debitorennummer")
});
export { _field_legacydebitornumbers2 as "_field_legacyDebitorNumbers" }